import React, { useState, useEffect } from "react";
import "./PhoneInput.css";
import countryCodes from "./countryCodes.json"; 

const PhoneInput = ({ label, value, placeholder, handlePhoneChange, onCountryChange, ...props }) => {
  const [selectedCountry, setSelectedCountry] = useState(countryCodes[0]);

  useEffect(() => {
    const defaultCountry = countryCodes.find((c) => c.code === "TR");
    if (defaultCountry) {
      setSelectedCountry(defaultCountry);
      onCountryChange?.(defaultCountry.dialCodes[0]);
    }
  }, [onCountryChange]);

  const handleCountryChange = (e) => {
    const country = countryCodes.find((c) => c.code === e.target.value);
    setSelectedCountry(country);
    onCountryChange?.(country.dialCodes[0]);
  };

  return (
    <div className="phone-input-container">
      {label && <label className="phone-label">{label}</label>}
      <div className="phone-input-wrapper">
        <div className="country-select">
          <img src={selectedCountry.image} alt={selectedCountry.name} className="flag-icon" />
          <select value={selectedCountry.code} onChange={handleCountryChange}>
            {countryCodes.map((country) => (
              <option key={country.code} value={country.code}>
                ({country.dialCodes[0]})
              </option>
            ))}
          </select>
        </div>
        <input
          type="number"
          className="phone-input"
          placeholder={placeholder}
          value={value}
          onChange={handlePhoneChange}
          {...props}
        />
      </div>
    </div>
  );
};

export default PhoneInput;
